import { Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { dummytabledata, tableColumns } from '../../../Data/DataTable/JourneyLocation/Journeylocation';
import axios from 'axios';
import EditJourney from './EditJourney';
import AddJourney from './AddJourney';
import { Link } from 'react-router-dom';
import { ServerPath } from '../../../Constant';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { _axios } from '../../../utils/axios'; 


const DataTablesContain = () => {
  const [journey, setJourney] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${ServerPath}/journey/list`);
        const actualData = response?.data?.data;
        console.log(actualData)
        const locData = actualData.map(loc => ({
          ...loc,
          location_name: <div className="align-self-center"><div>{loc?.location_name}</div></div>,
          status: <span
            className={`badge rounded-pill ${loc?.status === 1 ? 'badge-success' : 'badge-danger'}`}
            data-bs-toggle="modal"
            data-bs-target=".bd-example-modal-sm"
          >
            {loc?.status === 1 ? 'Active' : 'Inactive'}
          </span>,
          action: (
            <div className="action d-flex justify-content-center">
              <div className="edit" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                {loc && <EditJourney journey={loc} />}
              </div>
              <div className="delete">
                <Button to="#" onClick={(e) => handleDeleteID(loc?.loc_id, e)} className="btn-square btn btn-danger mx-2"><i className="icon-trash"></i></Button>
              </div>
            </div>
          ),
        }));
        setJourney(locData);
        console.log("loc = ", locData)
      } catch (error) {
        console.error('Error fetching tag details:', error);
      }
    };
    fetchData();
  }, []);

  const handleDeleteID = async (loc_id, event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      customClass: {
        container: 'swal2-container'
      }
    });

    if (result.isConfirmed) {
      try {
        await _axios.delete(`${ServerPath}/journey/${loc_id}`);
        setJourney(prevLoc => prevLoc.filter(loc => loc.loc_id !== loc_id));
        Swal.fire(
          'Deleted!',
          'Your journey details has been deleted.',
          'success'
        );
      } catch (error) {
        console.error('Error deleting journey details:', error);
        Swal.fire(
          'Error!',
          'There was an error deleting the journey details.',
          'error'
        );
      }
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
      setToggleDelet(!toggleDelet);
      setJourney(journey.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
      setSelectedRows('');
    }
  };

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6'>
          <Breadcrumbs mainTitle="Journey Locations" parent="Tables" title="Journey Locations" />
        </div>
        <div className='col-12 col-md-6 col-lg-6'>
          <AddJourney />
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              {/* <HeadingCommon Heading={DataTableHeading}  /> */}
              <CardBody className='pt-0'>
                {(selectedRows.length !== 0) &&
                  <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data?</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                  </div>
                }
                <DataTable
                  className='data-tables theme-scrollbar pt-4'
                  data={journey}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleDelet}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>

  );

};
export default DataTablesContain;